const NIF_REGEX = /^[KLM0-9][0-9]{7}[a-zA-Z0-9]/
const NIE_REGEX = /^[XYZT][0-9]{6}[A-Z0-9]/
const CIF_REGEX = /^[PQSNWR][0-9]{7}[A-Z0-9]/
const CIF2_REGEX = /^[ABCDEFGHJUV][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]/

export abstract class Identification {
  private _codeId: string
  private _isCompany = false

  constructor (codeId: string) {
    let matched = false
    if (NIF_REGEX.test(codeId)) {
      matched = true
      this.validateNIF(codeId)
      this._isCompany = false
    }
    if (NIE_REGEX.test(codeId)) {
      this.validateNIE(codeId)
      matched = true
      this._isCompany = false
    }
    if (CIF_REGEX.test(codeId)) {
      this.validateCIF(codeId)
      matched = true
      this._isCompany = true
    }
    if (CIF2_REGEX.test(codeId)) {
      this.validateCIF2(codeId)
      matched = true
      this._isCompany = true
    }
    if (matched === false) {
      throw new TypeError('Wrong Account id')
    }
    this._codeId = codeId
  }

  codeId (): string {
    return this._codeId
  }

  isCompany (): boolean {
    return this._isCompany
  }

  private validateNIF (nifString: string): void {
    const keyString = 'TRWAGMYFPDXBNJZSQVHLCKE'
    const letter = nifString.slice(-1).toUpperCase()
    const numbers = parseInt(nifString.slice(0, nifString.length - 1), 10)
    const position = numbers % 23
    const expectedLetter = keyString.charAt(position)
    if (expectedLetter !== letter) {
      throw new TypeError('Wrong NIF format')
    }
  }

  private validateNIE (nieString: string): void {
    const keyString = 'TRWAGMYFPDXBNJZSQVHLCKE'
    const letter = nieString.slice(-1).toUpperCase()
    const parsedNieString = nieString.replace('Y', '1').replace('X', '0').replace('Z', '2')
    const numbers = parseInt(parsedNieString.slice(0, parsedNieString.length - 1), 10)
    const position = numbers % 23
    const expectedLetter = keyString.charAt(position)
    if (expectedLetter !== letter) {
      throw new TypeError('Wrong NIE format')
    }
  }

  private validateCIF (cifString: string): void {
    const keyString = 'JABCDEFGHI'
    const centralNumbers = cifString.slice(1, cifString.length - 1)
    const lastLetter = cifString.slice(-1).toUpperCase()
    const calculatedDigit = this.calculateCifLastDigit(centralNumbers)
    const expectedLetter = keyString.charAt(calculatedDigit)
    if (expectedLetter !== lastLetter) {
      throw new TypeError('Wrong CIF format')
    }
  }

  private validateCIF2 (cifString: string): void {
    const centralNumbers = cifString.slice(1, cifString.length - 1)
    const lastNumber = parseInt(cifString.slice(-1))
    const calculatedDigit = this.calculateCifLastDigit(centralNumbers)
    if (lastNumber !== calculatedDigit) {
      throw new TypeError('Wrong CIF format')
    }
  }

  private calculateCifLastDigit (numberString: string): number {
    let totalSum = 0
    for (let i = 0; i < numberString.length; i++) {
      const currentNumner = parseInt(numberString.charAt(i), 10)
      if (i % 2 !== 0) {
        totalSum += currentNumner
      } else {
        totalSum += this.sumNumberedString((currentNumner * 2).toString())
      }
    }
    const totalSumString = totalSum.toString()
    const lastDigit = parseInt(totalSumString.slice(-1), 10)
    return lastDigit > 0 ? 10 - lastDigit : 0
  }

  private sumNumberedString (numberString: string): number {
    let totalSum = 0
    for (let i = 0; i < numberString.length; i++) {
      const currentNumner = parseInt(numberString.charAt(i), 10)
      totalSum += currentNumner
    }
    return totalSum
  }
}
